
const BASE_URL = 'https://api.coinnexs.com/api';

export interface AdminWithdrawalEntry {
    id: string;
    oldId: number;
    userId: string;
    userName: string;
    amount: string;
    asset: string;
    status: 'PENDING' | 'APPROVED' | 'REJECTED';
    destinationAddress: string;
    requestedAt: string;
}

export interface AdminWithdrawalListResponse {
    success: boolean;
    data: AdminWithdrawalEntry[];
}

export interface AdminWithdrawalDetail {
    id: string;
    oldId: number;
    userName: string;
    userEmail: string;
    amount: string;
    asset: string;
    status: 'PENDING' | 'APPROVED' | 'REJECTED';
    destinationAddress: string;
    requestedAt: string;
    reviewedAt: string | null;
    reviewedBy: string | null;
    remarks: string | null;
}

export interface AdminWithdrawalDetailResponse {
    success: boolean;
    data: AdminWithdrawalDetail;
}

class AdminWithdrawalService {
    private async request<T>(endpoint: string, options: RequestInit = {}): Promise<T> {
        const token = localStorage.getItem('coinnexs_token');
        const headers: Record<string, string> = {
            ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
            'Content-Type': 'application/json',
            ...(options.headers as Record<string, string>),
        };

        try {
            const response = await fetch(`${BASE_URL}${endpoint}`, {
                ...options,
                headers,
            });

            const data = await response.json();
            return data as T;
        } catch (error) {
            console.error(`Admin Withdrawal API Error (${endpoint}):`, error);
            throw error;
        }
    }

    async listAllWithdrawals(params: { page?: number; limit?: number; search?: string } = {}): Promise<AdminWithdrawalListResponse> {
        const query = new URLSearchParams();
        if (params.page) query.append('page', params.page.toString());
        if (params.limit) query.append('limit', params.limit.toString());
        if (params.search) query.append('search', params.search);

        const endpoint = `/admin/withdrawals${query.toString() ? `?${query.toString()}` : ''}`;
        return this.request<AdminWithdrawalListResponse>(endpoint);
    }

    async getWithdrawalDetail(withdrawalId: string): Promise<AdminWithdrawalDetailResponse> {
        return this.request<AdminWithdrawalDetailResponse>(`/admin/withdrawals/${withdrawalId}`);
    }

    async approveWithdrawal(withdrawalId: string): Promise<{ success: boolean; data: boolean }> {
        return this.request<{ success: boolean; data: boolean }>(`/admin/withdrawals/${withdrawalId}/approve`, {
            method: 'POST',
            body: JSON.stringify({}),
        });
    }

    async rejectWithdrawal(withdrawalId: string, remarks: string): Promise<{ success: boolean; data: boolean }> {
        return this.request<{ success: boolean; data: boolean }>(`/admin/withdrawals/${withdrawalId}/reject`, {
            method: 'POST',
            body: JSON.stringify({ remarks }),
        });
    }
}

export const adminWithdrawalService = new AdminWithdrawalService();
